/* Textos das confirmações de exclusão de empresa e de envio de orçamento/pedido de venda. */
export const TEXTOS_CONFIRMACOES_EMPRESA_VENDA = {
  pt: {
    "Excluir empresa": "Excluir empresa",
    "Excluir empresas": "Excluir empresas",
    "Excluir selecionadas": "Excluir selecionadas",
    "Tem certeza que deseja excluir a empresa": "Tem certeza que deseja excluir a empresa",
    "Enviar orçamento": "Enviar orçamento",
    "Enviar pedido de venda": "Enviar pedido de venda",
    "Deseja enviar este orçamento por e-mail para o cliente abaixo?":
      "Deseja enviar este orçamento por e-mail para o cliente abaixo?",
    "Deseja enviar este pedido de venda por e-mail para o cliente abaixo?":
      "Deseja enviar este pedido de venda por e-mail para o cliente abaixo?",
    "O cliente não tem e-mail cadastrado — o envio pode falhar.":
      "O cliente não tem e-mail cadastrado — o envio pode falhar.",
  },
  en: {
    "Excluir empresa": "Delete company",
    "Excluir empresas": "Delete companies",
    "Excluir selecionadas": "Delete selected",
    "Tem certeza que deseja excluir a empresa": "Are you sure you want to delete the company",
    "Enviar orçamento": "Send quote",
    "Enviar pedido de venda": "Send sales order",
    "Deseja enviar este orçamento por e-mail para o cliente abaixo?":
      "Do you want to email this quote to the customer below?",
    "Deseja enviar este pedido de venda por e-mail para o cliente abaixo?":
      "Do you want to email this sales order to the customer below?",
    "O cliente não tem e-mail cadastrado — o envio pode falhar.":
      "The customer has no registered e-mail — sending may fail.",
  },
  es: {
    "Excluir empresa": "Eliminar empresa",
    "Excluir empresas": "Eliminar empresas",
    "Excluir selecionadas": "Eliminar seleccionadas",
    "Tem certeza que deseja excluir a empresa": "¿Seguro que desea eliminar la empresa",
    "Enviar orçamento": "Enviar presupuesto",
    "Enviar pedido de venda": "Enviar pedido de venta",
    "Deseja enviar este orçamento por e-mail para o cliente abaixo?":
      "¿Desea enviar este presupuesto por correo al cliente indicado abajo?",
    "Deseja enviar este pedido de venda por e-mail para o cliente abaixo?":
      "¿Desea enviar este pedido de venta por correo al cliente indicado abajo?",
    "O cliente não tem e-mail cadastrado — o envio pode falhar.":
      "El cliente no tiene correo registrado — el envío puede fallar.",
  },
  "zh-CN": {
    "Excluir empresa": "删除公司",
    "Excluir empresas": "删除公司",
    "Excluir selecionadas": "删除所选",
    "Tem certeza que deseja excluir a empresa": "确定要删除该公司吗",
    "Enviar orçamento": "发送报价单",
    "Enviar pedido de venda": "发送销售订单",
    "Deseja enviar este orçamento por e-mail para o cliente abaixo?":
      "是否将此报价单通过电子邮件发送给以下客户？",
    "Deseja enviar este pedido de venda por e-mail para o cliente abaixo?":
      "是否将此销售订单通过电子邮件发送给以下客户？",
    "O cliente não tem e-mail cadastrado — o envio pode falhar.":
      "该客户未登记电子邮件地址，发送可能失败。",
  },
};
